import { Flex, Link } from '@folksam/ui-next/components';
import React from 'react';
import Button from '../components/Button';

export default function SecondButtonContainer({ buttonText, buttonLink }) {
    return (
        <Flex sx={{ justifyContent: 'center' }} marginTop={'5'}>
            <Button
                as={Link}
                sx={{
                    width: ['100%', null, null, 'fit-content'],
                    '&:hover': { textDecoration: 'none', color: 'white' }
                }}
                href={buttonLink}
            >
                {buttonText}
            </Button>
        </Flex>
    );
}
